(() => {
 'use strict';
 const rail=document.querySelector('[data-r294-rail]');if(!rail)return;
 const action=rail.querySelector('a'),mobile=matchMedia('(max-width:760px)');
 const opener=rail.querySelector('[data-r294-open]');
 let galleryOwner=false,boundDialog=null;
 const media=()=>window.__R290_MEDIA__;
 function syncGallery(){
  const api=media();if(!opener||!api?.switchFormat)return;
  opener.hidden=false;
 }
 function connectGallery(){
  const api=media(),dialog=api?.dialog;if(!dialog)return;
  if(boundDialog!==dialog){
   boundDialog=dialog;
   dialog.addEventListener('close',()=>{
    const restore=galleryOwner||api.opener===opener;galleryOwner=false;update();
    if(!restore||dialog.dataset.r295Exit==='choose')return;
    // The rail is intentionally hidden while the modal is open. Wait for its
    // actual CSS visibility, not one assumed animation frame, before focusing.
    let frames=0;const restoreFocus=()=>{
     if(dialog.open||dialog.dataset.r295Exit==='choose')return;
     const focused=document.activeElement;
     if(focused&&focused!==document.body&&focused!==opener&&!dialog.contains(focused))return;
     update();if(getComputedStyle(rail).visibility==='visible'){opener.focus({preventScroll:true});return;}
     if(++frames<20)requestAnimationFrame(restoreFocus);
    };requestAnimationFrame(restoreFocus);
   });
  }
  window.__TOS295_EXPERIENCE__?.enhance();syncGallery();
 }
 opener?.addEventListener('click',()=>{
  if(!media()?.switchFormat||media().active)return;
  const chosen=document.querySelector('[data-choice-preview]')?.dataset.format;
  const format=window.__TOS295_EXPERIENCE__?.lastFormat||(['500','1000'].includes(chosen)?chosen:'500');
  galleryOwner=true;media().open(format,opener);connectGallery();update();
 });
 let touchBound=false;
 let scheduled=0,selectorVisible=false;
 const selector=document.querySelector('#choice-form');
 const sizes=()=>{const size=Math.ceil(rail.getBoundingClientRect().height)+28;for(const key of ['--f287-rail-space','--rail-space'])document.documentElement.style.setProperty(key,size+'px');};
 const visible=el=>!!el&&getComputedStyle(el).visibility!=='hidden'&&!!el.getClientRects().length;
 function update(){
  scheduled=0;
  const focused=document.activeElement;
  const typing=mobile.matches&&focused?.matches('input:not([type=radio]):not([type=checkbox]),textarea,select,[contenteditable=true]');
  const overlay=document.querySelector('dialog[open],cart-drawer.active,[data-house-cart][aria-hidden="false"],#shopify-pc__banner:not([style*="display: none"])');
  const hide=!!(typing||visible(overlay)||selectorVisible);
  rail.toggleAttribute('data-quiet-off',hide);
  // Visibility, not aria-hidden on a focused ancestor, keeps keyboard semantics safe.
 }
 const schedule=()=>{syncGallery();if(opener&&!touchBound&&media()?.bindTouchButtons){media().bindTouchButtons(opener);touchBound=true;}if(!scheduled)scheduled=requestAnimationFrame(update);};
 if(selector)new IntersectionObserver(entries=>{selectorVisible=entries[0].isIntersecting;schedule();},{threshold:0}).observe(selector);
 new ResizeObserver(sizes).observe(rail);sizes();
 new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','aria-hidden','class','hidden']});
 document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);document.addEventListener('three-olives:cart-state',schedule);
 window.visualViewport?.addEventListener('resize',schedule);mobile.addEventListener('change',schedule);
 action.addEventListener('click',()=>{rail.dataset.lastAction='choose-format';});
 schedule();update();
 window.__R294_RAIL__={rail,action,update,sizes};
})();
